import { cva, VariantProps } from 'class-variance-authority'
import { toast as toastifyToast, ToastOptions } from 'react-toastify'

import { DefaultToastStyle } from '@/shared/ui'

import { CloseButton } from './close-button'
import { cn } from '../style'

const toastVariants = cva('', {
  variants: {
    align: {
      left: 'justify-start text-start',
      center: 'justify-center text-center',
      right: 'justify-end text-end',
    },
  },
})

type Props = ToastOptions &
  VariantProps<typeof toastVariants> & {
    closable?: boolean
  }

export const toast = (
  message: string,
  { closable = false, align = 'left', className, ...options }: Props = {},
) => {
  const toastId = toastifyToast(message, {
    ...(closable && {
      autoClose: false,
      closeButton: CloseButton,
    }),
    className: cn(DefaultToastStyle, toastVariants({ align, className })),
    ...options,
  })

  return toastId
}

toast.dismiss = toastifyToast.dismiss
